module.exports = __webpack_public_path__ + "static/media/card-bg.34f33490.png";